import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { CompanyForm } from "@/features/companies";
import { apiClient, getErrorMessage } from "@/features/shared";
import { PageContainer, useSnackbar } from "@/features/ui";

export const CreateCompany = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      await apiClient.post("companies", formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat perusahaan"));

      showSnackbar(
        getErrorMessage(error, "Gagal membuat perusahaan")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Perusahaan"
      breadcrumbs={[
        { title: "Perusahaan", path: "/setting/companies" },
        { title: "Tambah" },
      ]}
    >
      <CompanyForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
